import axios from "axios";
import { IInvoicesAllSearch } from "./invoices/interfaces/invoices-all-search.interface";

const prefix: string = 'DeliveryDocuments/';

export const getAllInvoices = (search: IInvoicesAllSearch) => {
    return axios.post(`${prefix}GetAllInvoices`, search);
}